export const TRANSLATION_GROUP_SIDEBAR = Symbol('sidebar');

export const ADMIN_PARTNERS_MENU_ITEM = Symbol('admin.partners');
export const ADMIN_FINANCE_MENU_ITEM = Symbol('admin.finance');
export const ADMIN_PLAYERS_MENU_ITEM = Symbol('admin.players');
export const ADMIN_PARTNERSHIP_MENU_ITEM = Symbol('admin.partnership');
export const ADMIN_PERSONNEL_MENU_ITEM = Symbol('admin.personnel');
export const ADMIN_SETTINGS_MENU_ITEM = Symbol('admin.settings');
export const ADMIN_MIRRORS_MENU_ITEM = Symbol('admin.mirrors');
export const ADMIN_EXPORTS_MENU_ITEM = Symbol('admin.exports');
// TODO: when tabs in general_settings will be removed, create separate key for general settings

export const AFFILIATE_TRACKING_LINKS_MENU_ITEM = Symbol('affiliate.tracking.links');
export const AFFILIATE_REPORTS_MENU_ITEM = Symbol('affiliate.reports');
export const AFFILIATE_PARTNERSHIP_MENU_ITEM = Symbol('affiliate.partnership');
export const AFFILIATE_EXPORTS_MENU_ITEM = Symbol('affiliate.exports');
